// <faq-search>: client-side filter for the FAQ section (sections/faq.liquid).
// Filters accordion items by question + answer text, hides empty categories,
// and shows a "no results" message. Diacritics-insensitive ("cestina" matches "cestina" with hacek).
const normalize = (value) =>
  (value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');

class FaqSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-faq-search-input]');
    this.body = this.querySelector('.faq__body');
    this.items = Array.from(this.querySelectorAll('.faq__item'));
    this.noResults = this.querySelector('[data-faq-noresults]');

    // Defined inline in sections/faq.liquid (runs on load); re-run on in-page hash links.
    if (window.faqOpenFromHash) window.addEventListener('hashchange', window.faqOpenFromHash);

    if (!this.input || !this.body) return;

    this.items.forEach((item) => {
      item.dataset.haystack = normalize(item.dataset.search);
    });

    // Group items under their preceding category header (flat DOM).
    this.categories = [];
    let current = null;
    Array.from(this.body.children).forEach((el) => {
      if (el.matches('[data-faq-category]')) {
        current = { header: el, items: [] };
        this.categories.push(current);
      } else if (el.classList.contains('faq__item') && current) {
        current.items.push(el);
      }
    });

    this.input.addEventListener('input', this.onInput.bind(this));
  }

  onInput() {
    const query = normalize(this.input.value.trim());
    let anyVisible = false;

    this.items.forEach((item) => {
      const match = query === '' || item.dataset.haystack.includes(query);
      item.hidden = !match;
      if (match) anyVisible = true;
    });

    this.categories.forEach((cat) => {
      cat.header.hidden = !cat.items.some((item) => !item.hidden);
    });

    if (this.noResults) this.noResults.hidden = anyVisible;
  }
}

customElements.define('faq-search', FaqSearch);
